import React, {useState} from "react";

const BaseInput = ({ type = "text", ...props }) => {
    const {
        name,
        id,
        className,
        maxLength,
        placeholder,
        required,
        onChange,
        value,
        readOnly,
        disabled,
        hasError = false,
        autoFocus,
        nextFocus = true,
        enterSubmit = '',
        ...rest
    } = props;
    const readOnlyClass = "read-only:bg-gray-200 read-only:cursor-not-allowed read-only:text-[#989898]";
    const disabledClass = "disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-[#989898]";
    const borderClass = (hasError === false) ? "border-tenken-gray-500" : "border-red-500";
    const classStyle = `lg:h-10 h-[38px] lg:text-base text-[15px] ${(readOnly !== true && disabled !== true) && 'focus:bg-yellow-100'} placeholder:text-gray-400 bg-white rounded-[6px] p-2 `;
    const inputClass = `${readOnlyClass} ${disabledClass} ${classStyle} border ${borderClass} focus:ring-transparent focus:border-gray-500 ${className || ''}`;
    const [isFocus, setIsFocus] = useState(false);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const inputs = Array.from(document.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]), textarea, select'));
            const currentIndex = inputs.findIndex((input) => input === e.target);
            const nextInput = inputs[currentIndex + 1];
            if (nextInput) {
                nextInput.focus();
                if (nextInput.tagName.toLowerCase() === 'textarea'){
                    nextInput.setSelectionRange(nextInput.value.length,nextInput.value.length);
                }
            } else {
                if (enterSubmit) {
                    document.getElementById(enterSubmit).click();
                }
                e.target.blur();
            }
        }
    };

    return (
        <input 
            type={type} 
            className={inputClass}
            name={name}
            id={id ? id : null}
            maxLength={maxLength ? maxLength : null}
            placeholder={(!isFocus && placeholder) ? placeholder: null}
            value={value !== undefined ? value : null}
            onChange={onChange ? onChange : null}
            required={required !== undefined ? required : false}
            readOnly={readOnly !== undefined ? readOnly : null}
            disabled={disabled !== undefined ? disabled : null}
            onFocus={(e) => setIsFocus(true)}
            onBlur={(e) => setIsFocus(false)}
            onKeyDown={nextFocus ? handleKeyDown : null}
            autoFocus={autoFocus && !isFocus}
            {...rest}
        />
    );
};

export default BaseInput;